import React from 'react';
import { Grid } from '@material-ui/core';
import { useQuery } from 'react-query';
import { getData } from 'src/Utils/api';
import usePersonalInfo from 'src/Views/PersonalInfo/usePersonalInfo';
import { NAME_KEY, LAST_NAME_KEY } from 'src/Utils/constants';
import { FormSection, SectionTitle, FormGrid, FieldLabel, OwnerName, } from './styles';
import SearchableSelect from '../Common/SearchableSelect/SearchableSelect';
import { FormGridItem } from 'src/Views/CreateTicketPage/TicketForm/styles';
import { sortAssignableUsersByLastName } from 'src/Utils/adminUsersService';
export var TicketManagementSection = function (_a) {
    var formData = _a.formData, onInputChange = _a.onInputChange, style = _a.style;
    var _b = useQuery('assignableUsers', function () {
        return getData('/admin_users').then(function (res) { return res.admin_users || []; });
    }).data, assignableUsers = _b === void 0 ? [] : _b;
    var userProfile = usePersonalInfo().data;
    return (React.createElement(FormGridItem, { style: style },
        React.createElement(FormSection, null,
            React.createElement(SectionTitle, null, "Gesti\u00F3n del ticket"),
            React.createElement(FormGrid, { container: true, spacing: 2 },
                React.createElement(Grid, { item: true, xs: 6 },
                    React.createElement(FieldLabel, null, "Propietario del ticket"),
                    React.createElement(OwnerName, { variant: "body2" }, userProfile ? userProfile[NAME_KEY] + " " + userProfile[LAST_NAME_KEY] : 'Cargando...')),
                React.createElement(Grid, { item: true, xs: 6 },
                    React.createElement(SearchableSelect, { clearable: true, label: "Asignar ticket a", value: formData.assignee_id, onChange: function (value) { return onInputChange('assignee_id', value); }, options: sortAssignableUsersByLastName(assignableUsers).map(function (user) { return ({
                            value: user.id,
                            label: user.first_name + " " + user.last_name
                        }); }), placeholder: "Selecciona un administrador" }))))));
};
export default TicketManagementSection;
